<div class="w-100 bg-slate-5 h-100">
    <div
        [class.sidebar-opened]="menuService.sidebarOpened"
        class="content-wrapper d-flex h-100">
        <div
            *ngIf="!fullScreen && (user$ | async)"
            class="sidebar">
            <app-menu></app-menu>
        </div>
        <div
            [class.w-100]="fullScreen || !(user$ | async)"
            [ngClass]="{ 'p-0': fullScreen, outlet: (user$ | async) }"
            class="h-100 position-relative">
            <div class="h-100">
                <div
                    *ngIf="!fullScreen && (user$ | async)"
                    class="fixed-header">
                    <app-header></app-header>
                </div>
                <div
                    *ngIf="user$ | async; else unAuthenticated"
                    [ngClass]="{
                        ' h-100 w-100 g-md-3 g-xl-5  pt-4 pb-5 main-screen-wrapper': !fullScreen,
                        'main-screen-wrapper--compact-board': compactBoardLayout && !fullScreen,
                        'container-fluid p-0': fullScreen,
                        'cdk-visually-hidden': (twilioService.fullWindowControllerTmpl$ | async)
                    }">
                    <router-outlet (activate)="onActivate($event)"></router-outlet>
                </div>
                <ng-template #unAuthenticated>
                    <router-outlet (activate)="onActivate($event)"></router-outlet>
                </ng-template>
                <app-template-placeholder
                    [templateReplaySubject]="twilioService.fullWindowControllerTmpl$"></app-template-placeholder>
            </div>
        </div>
    </div>
</div>
<app-modals></app-modals>
<div
    *ngIf="asideOpen$ | async"
    (click)="closeAll()"
    class="modal-backdrop fade show modal-slide-show"></div>
<app-alert
    [data]="alerts$ | async"
    [showModal]="
        (alerts$ | async).errors.length ||
        (alerts$ | async).notifications.length ||
        (alerts$ | async).simple ||
        (alerts$ | async).confirmAction ||
        (alerts$ | async).customAlert ||
        (alerts$ | async).simpleInput
    "></app-alert>

<app-notifications-list *ngIf="(overlays$ | async).notifications"></app-notifications-list>
<!-- PERF: removed dead <app-order-create> overlay — overlays.orderCreate is never set
     (all overlayService.toggle('orderCreate') calls are commented out; order-create is
     router-driven via /order/create/*). Removing it lets OrderCreateModule leave the eager bundle. -->
<app-supplier-stepthrough *ngIf="(overlays$ | async).supplierStepthrough && (user$ | async)"></app-supplier-stepthrough>
<app-floating-pill *ngIf="(user$ | async) && !fullScreen"></app-floating-pill>
<app-template-placeholder [templateReplaySubject]="twilioService.floatingTmpl$"></app-template-placeholder>
<!-- <app-floating-spinner [showSpinner]="(overlays$ | async).busyIndicator"></app-floating-spinner> -->
